module.exports = __webpack_public_path__ + "img/slide-2.2c58419b.jpg";